import * as React from 'react';
import { BaSeCheckbox, BaSeHeading6, BaSeInput, BaSeTheme } from '@base/react';
import {
  CustomFilterContent,
  WrapperCheckbox,
} from '../certificados-cliente-styled';
import {
  CHECKBOX_OPTIONS,
  CHECKBOX_REVERSE,
} from '../utils/certificados.utils';

const { azulSebrae36, cinzaSebrae45 } = BaSeTheme.colors.institucionais;

export const CertificadoCustomFilter = ({
  checkFilter,
  searchText,
  isMobile,
  onCheckChange,
  onSearchChange,
  onSearch,
}) => {
  const placeholder =
    checkFilter.type === 'CPF'
      ? '000.000.000-00'
      : CHECKBOX_OPTIONS[checkFilter.index] ?? 'Pesquise aqui..';

  return (
    <CustomFilterContent>
      <BaSeHeading6 color={cinzaSebrae45}>Buscar por:</BaSeHeading6>
      <div style={{ display: 'flex', gap: 8 }}>
        {CHECKBOX_OPTIONS.map((option, i) => (
          <WrapperCheckbox key={option} index={i}>
            <BaSeCheckbox
              label={option}
              checked={i === checkFilter.index}
              onChange={() =>
                onCheckChange({ index: i, type: CHECKBOX_REVERSE[option] })
              }
              shape="circle"
            />
          </WrapperCheckbox>
        ))}
      </div>
      <BaSeInput
        align="start"
        color="default"
        inputMode="search"
        mask={checkFilter.type === 'CPF' ? 'cpf' : ''}
        iconButton={{
          action: onSearch,
          name: 'search',
          color: azulSebrae36,
          typeButton: 'base-icon',
          type: 'secondary',
        }}
        onSpecificKeyDown={[{ listenerKey: 'Enter', callback: onSearch }]}
        onChange={onSearchChange}
        placeholder={placeholder}
        size="medium"
        typeInput="text"
        value={searchText}
        width={!isMobile ? '250px' : '100%'}
      />
    </CustomFilterContent>
  );
};
